var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,_vm._b({key:_vm.component,tag:"component",model:{value:(_vm.details),callback:function ($$v) {_vm.details=$$v},expression:"details"}},'component',{action: _vm.action, name: _vm.name},false))}
var staticRenderFns = []

export { render, staticRenderFns }